var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#8EC3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71777 5C8.11474 5 8.4365 5.32179 8.43652 5.71875V7.99121L10.3301 8.5957C10.7083 8.71625 10.9174 9.12079 10.7969 9.49902C10.6763 9.87716 10.2717 10.0863 9.89355 9.96582L7.76465 9.28711C7.3345 9.14991 7.06181 8.74866 7.06836 8.31934C7.02374 8.20596 6.99902 8.08234 6.99902 7.95312V5.71875C6.99904 5.3218 7.32083 5.00002 7.71777 5Z",
    fill: "#fff"
  })));
}

export default SvgClockIcon;